import nuscastApi from "./api/nuscastApi.js";
import store from "./store.js";
import history from "./history.js";

const io = require('socket.io-client');
let socket;
let E = {};

E.checkIOS = function () {
    let check = /iphone|ipod|ipad/.test(window.navigator.userAgent.toLowerCase());
    if (check) {
        window.$('body').css('background-color', '#e0e2d7');
    }
    return check;
};

E.checkIE = function () {
    let userAgent = window.navigator.userAgent;
    return userAgent.indexOf('MSIE') !== -1 || (window.navigator.appName === 'Netscape' && userAgent.indexOf('Trident/') !== -1);
};

E.check3rdPartyCookie = function () {
    let frame = document.createElement("iframe");
    frame.src = 'https://nuscast.ota.com.cn/start.html';
    frame.style.position = "relative";
    frame.style.left = "-9999px";
    frame.id = "checkFrame";
    document.body.appendChild(frame);
    window.addEventListener("message", function (evt) {
        if (evt.data === 'MM:3PCunsupported') {
            store.dispatch({
                type: 'cookieChecker',
                value: true
            });
        } else if (evt.data === 'MM:3PCsupported') {
            window.$('#checkFrame').remove();
        }
    }, false);
};

function initSocket() {
    socket = io.connect('', {path: '/api/socket.io'});
    socket.on('online', function (d) {
        store.dispatch({
            type: 'online',
            value: d.online
        });
    });
}

E.initApp = function () {
    E.check3rdPartyCookie();
    E.startLoader();
    E.collapseMemory();
    initSheet();
    initSocket();
    nuscastApi.getUserFromLocalStorage()
        .then(user => {
            return E.initStepsAfterLogin(user);
        })
        .then(_ => E.stopLoader())
        .catch(reason => {
            E.stopLoader();
            let token = getQueryParam('token');
            if (token) {
                handleTokenLogin(token);
            } else {
                if (reason && reason.responseJSON && reason.responseJSON.needLogin)
                    E.showLoginModal({reason: E.showLoginModal.messages.NUSCAST_API});
                console.log('xxx ERR nuscastApi.getUserFromLocalStorage()', reason);
            }
        });
};

function handleTokenLogin(token) {
    E.startLoader();
    nuscastApi.getUserFromToken(token).then((user) => {
        window.location.href = E.removeQueryParam('token');
        return E.initStepsAfterLogin(user);
    }).then(_ => E.stopLoader())
        .catch(reason => {
            E.stopLoader();
            if (reason.responseJSON) {
                store.dispatch({
                    type: 'addAlert',
                    value: {content: reason.responseJSON.error || '', title: 'Login failed', type: 'danger'}
                });
            }
            console.log('xxx ERR nuscastApi.getUserFromToken()', reason);
        });
}

E.handleLoginButtonClick = function (matric, pw) {
    E.startLoader();
    nuscastApi.getUserFromLogin(matric, pw)
        .then(user => {
            return E.initStepsAfterLogin(user);
        })
        .then(_ => E.stopLoader())
        .then(_ => {
            if (E.getVidFromPathname()) {
                location.reload();
            }
        })
        .catch(reason => {
            E.stopLoader();
            if (reason.responseJSON) {
                store.dispatch({
                    type: 'addAlert',
                    value: {content: reason.responseJSON.error || '', title: 'Login failed', type: 'danger'}
                });
            }
            console.log('xxx ERR nuscastApi.getUserFromLogin()', reason);
        });
};

E.initStepsAfterLogin = function (user) {
    store.dispatch({type: 'gotUser', value: user});
    window.localStorage.setItem('nuscastUser', JSON.stringify(store.getState().user));
    return nuscastApi.getUserModules(user)
        .then(profile => {
            store.dispatch({type: 'gotUser', value: {name: profile.name}});
            window.localStorage.setItem('nuscastUser', JSON.stringify(store.getState().user));
            store.dispatch({type: 'banlist', value: profile.banlist});
            store.dispatch({type: 'modules', value: profile.modules});
            store.dispatch({
                type: 'miscVideos', value: {
                    trending: profile.trending,
                    latest: profile.latest,
                    recent: profile.recent
                }
            });
            store.dispatch({
                type: 'notification',
                value: profile.notification
            });
            addRule('.cmt-list.cmt-self .cmt-content:before', 'content: "(Yours) ";color: green;');
            refreshBanlist();
            if (user && user.userID) {
                socket.on(user.userID, function (d) {
                    if (d.notification) {
                        store.dispatch({
                            type: 'notification',
                            value: store.getState().notification + 1
                        });
                    }
                });
            }
        });
};

E.handleLogoutOnClick = function () {
    nuscastApi.logout();
    store.dispatch({type: 'gotUser', value: null});
    store.dispatch({type: 'clearModules', value: null});
    store.dispatch({type: 'clearCollapse', value: {}});
    store.dispatch({type: 'banlist', value: []});
    let sheet = document.getElementById('dynamic');
    sheet.parentNode.removeChild(sheet);
    delete window.localStorage.nuscastUser;
};

E.handleModuleClick = function (mod, collapseBody) {
    if (!mod || !mod.ID)
        return;
    let ID = mod.ID;
    let modFromState = store.getState().modules.find(m => m.ID === ID);
    let hasVideoList = modFromState && modFromState.moduleVideoList;
    if (hasVideoList)
        return;
    E.startLoader({elem: collapseBody || null});
    nuscastApi.getVideoList(ID)
        .then(moduleVideoListObj => {
            store.dispatch({
                type: 'moduleVideoList', value: {
                    ID, moduleVideoListObj
                }
            });
            E.stopLoader({elem: collapseBody});
        })
        .catch(reason => {
            E.stopLoader({elem: collapseBody});
            if (reason && reason.responseJSON && reason.responseJSON.needLogin)
                E.showLoginModal({reason: E.showLoginModal.messages.NUSCAST_API});
            console.log('xxx ERR nuscastApi.handleModuleClick()', reason);
        });
};

E.handleOpenListClick = function (collapseBody) {
    if (store.getState().open.length > 0) return;
    E.startLoader({elem: collapseBody || null});
    nuscastApi.getOpenMod()
        .then(modules => {
            store.dispatch({
                type: 'openMod', value: modules.modules
            });
            E.stopLoader({elem: collapseBody});
        })
        .catch(reason => {
            E.stopLoader({elem: collapseBody});
            if (reason && reason.responseJSON && reason.responseJSON.needLogin)
                E.showLoginModal({reason: E.showLoginModal.messages.NUSCAST_API});
            console.log('xxx ERR nuscastApi.handleOpenListClick()', reason);
        });
};

E.handleOpenModuleClick = function (mod, collapseBody) {
    if (!mod || !mod.ID) return;
    let modFromState = store.getState().open.find(m => m.ID === mod.ID);
    if (modFromState && modFromState.moduleVideoList) {
        return;
    }
    E.startLoader({elem: collapseBody || null});
    nuscastApi.getOpenVideo(mod.ID)
        .then(openVideoList => {
            store.dispatch({
                type: 'openVideoList', value: {
                    moduleVideoListObj: openVideoList,
                    ID: mod.ID,
                }
            });
            E.stopLoader({elem: collapseBody});
        })
        .catch(reason => {
            E.stopLoader({elem: collapseBody});
            if (reason && reason.responseJSON && reason.responseJSON.needLogin)
                E.showLoginModal({reason: E.showLoginModal.messages.NUSCAST_API});
            console.log('xxx ERR nuscastApi.handleModuleClick()', reason);
        });
};

E.handleBugReportSubmit = function (elem) {
    if (!elem.text) return;
    nuscastApi.bugReportSubmit(elem.text)
        .then(store.dispatch({
            type: 'addAlert',
            value: {
                title: 'Bug report sent',
                content: 'Thank you very much for your bug report! We will handle it soon',
                type: 'success'
            }
        }))
        .catch(reason => console.log('xxxx ERR BugReportSubmit()', reason));
};

E.handleSearchTerm = function (term) {
    if (!term) term = '';
    store.dispatch({
        type: 'searchTerm',
        value: term
    });
    window.$("#openlist").unmark({
        done: function() {
            if (term.length > 0) {
                window.$("#openlist").mark(term);
            }
        }
    });
};

E.handleSearchBoxClick = function (listBody) {
    if (!window.$(listBody).hasClass('show')) {
        window.$('#open-title').click();
    }
};

E.getComments = function (ID) {
    return nuscastApi.getComments(ID)
        .catch(reason => {
            if (reason && reason.responseJSON && reason.responseJSON.needLogin)
                E.showLoginModal({reason: E.showLoginModal.messages.NUSCAST_API});
            console.log('xxxx ERR getComments()', reason);
            return [];
        });
};

E.getVideoInfo = function (currentVideo, ID = E.getVidFromPathname()) {
    if ((ID && !currentVideo) || (ID && currentVideo && ID !== currentVideo.ID && currentVideo.ID !== 'public_404')) {
        E.startLoader();
        nuscastApi.getVideoInfo(ID)
            .then((video) => {
                video.src = video.MP4 || video.main;
                store.dispatch({type: 'currentVideo', value: video});
                E.stopLoader();
            })
            .catch((reason) => {
                E.stopLoader();
                if (reason && reason.responseJSON && reason.responseJSON.needLogin)
                    E.showLoginModal({reason: E.showLoginModal.messages.NUSCAST_API});
                console.log('xxxx ERR getVideoInfo()', reason);
            });
    }
};

function getQueryParam(parameterName) {
    let result = null,
        tmp = [];
    let items = location.search.substr(1).split("&");
    for (let index = 0; index < items.length; index++) {
        tmp = items[index].split("=");
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    }
    return result;
}

E.removeQueryParam = function (parameterName) {
    let url = window.location.href;
    let urlparts = url.split('?');
    if (urlparts.length >= 2) {
        let prefix = encodeURIComponent(parameterName) + '=';
        let pars = urlparts[1].split(/[&;]/g);
        for (let i = pars.length; i-- > 0;) {
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }
        url = urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
        return url;
    } else {
        return url;
    }
};

function getStime(stime) {
    if (isNaN(stime) || stime === null) return 0;
    let time = Number(stime);
    if (time < 0) {
        return 0;
    } else {
        return time;
    }
}

function initSheet() {
    let head = document.head || document.getElementsByTagName('head')[0];
    let style = document.createElement('style');
    style.type = 'text/css';
    style.id = 'dynamic';
    let css = '';
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
    head.appendChild(style);
}

function addRule(selector, rules, index = 0) {
    let tag = document.getElementById('dynamic');
    let sheet = tag.sheet ? tag.sheet : tag.styleSheet;
    if ("insertRule" in sheet) {
        sheet.insertRule(selector + "{" + rules + "}", index);
    } else if ("addRule" in sheet) {
        sheet.addRule(selector, rules, index);
    }
}

function replaceRules(userID, blocked = true) {
    let tag = document.getElementById('dynamic');
    let sheet = tag.sheet ? tag.sheet : tag.styleSheet;
    let selector_0 = '[data-user="' + userID + '"].cmt-other.cmt';
    let selector_1 = '[data-user="' + userID + '"].cmt-other.cmt-list .cmt-content::before';
    if (sheet.cssRules) {
        for (let i = sheet.cssRules.length - 1; i >= 0; i--) {
            if (sheet.cssRules[i].selectorText === selector_0) {
                sheet.deleteRule(i);
            }
            if (sheet.cssRules[i].selectorText === selector_1) {
                sheet.deleteRule(i);
            }
        }
        addRule('[data-user="' + userID + '"].cmt-other.cmt', blocked ? 'display: none;' : 'display:block');
        addRule('[data-user="' + userID + '"].cmt-other.cmt-list .cmt-content::before', blocked ? 'content: "(Blocked) ";color:red;' : '');
    } else {
        for (let i = sheet.rules.length - 1; i >= 0; i--) {
            if (sheet.rules[i].selectorText === selector_0) {
                sheet.removeRule(i);
            }
            if (sheet.rules[i].selectorText === selector_1) {
                sheet.removeRule(i);
            }
        }
        addRule('[data-user="' + userID + '"].cmt-other.cmt', blocked ? 'display: none;' : 'display:block');
        addRule('[data-user="' + userID + '"].cmt-other.cmt-list .cmt-content::before', blocked ? 'content: "(Blocked) ";color:red;' : '');
    }
}

function removeRules(prefix) {
    let tag = document.getElementById('dynamic');
    let sheet = tag.sheet ? tag.sheet : tag.styleSheet;
    if (sheet.cssRules) {
        for (let i = sheet.cssRules.length - 1; i >= 0; i--) {
            if (sheet.cssRules[i].selectorText.startsWith(prefix)) {
                sheet.deleteRule(i);
            }
        }
    } else {
        for (let i = sheet.rules.length - 1; i >= 0; i--) {
            if (sheet.rules[i].selectorText.startsWith(prefix)) {
                sheet.removeRule(i);
            }
        }
    }
}

function getBanlist() {
    let banlist = store.getState().banlist;
    if (banlist) {
        if (Array.isArray(banlist)) {
            banlist = Array.from(new Set(banlist));
            return banlist;
        }
    }
    return [];
}

function refreshBanlist(list = null) {
    let banlist = list || getBanlist();
    if (banlist.length > 0) {
        banlist.forEach((item) => {
            replaceRules(item, true);
        });
    }
}

function addBanUser(user) {
    let banlist = getBanlist();
    let set = new Set(banlist);
    set.add(user.toUpperCase());
    banlist = Array.from(set);
    replaceRules(user.toUpperCase(), true);
    sendBanlist(banlist);
}

function sendBanlist(banlist) {
    nuscastApi.setBanlist(banlist).then((d) => {
        store.dispatch({type: 'banlist', value: d.banlist});
    }).catch((reason) => {
        if (reason && reason.responseJSON && reason.responseJSON.needLogin)
            E.showLoginModal({reason: E.showLoginModal.messages.NUSCAST_API});
        console.log('xxxx ERR sendBanlist()', reason);
    });
}

function removeBanUser(user) {
    let banlist = getBanlist();
    for (let i = 0; i < banlist.length; i++) {
        if (user.toUpperCase() === banlist[i].toUpperCase()) {
            replaceRules(user.toUpperCase(), false);
            banlist.splice(i, 1);
            sendBanlist(banlist);
        }
    }
}

function setContextMenu() {
    function menuCallBack(key, opt) {
        if (!E.abpinst) return;
        let ID = store.getState().currentVideo && store.getState().currentVideo.ID;
        if (key === 'goto') {
            E.abpinst.moveToTime(getStime(opt.$trigger[0].data.time / 1000));
        } else if (key === 'reply') {
            E.abpinst.showReply(opt.$trigger[0].id.substring(1));
        } else if (key === 'ban') {
            let user = opt.$trigger[0].getAttribute('data-user').toUpperCase();
            addBanUser(user);
        } else if (key === 'unban') {
            let user = opt.$trigger[0].getAttribute('data-user').toUpperCase();
            removeBanUser(user);
        } else if (key === 'del') {
            let dbid = opt.$trigger[0].id.substring(1);
            nuscastApi.deleteComment(dbid, ID).then(() => {
                window.$('#L' + dbid).remove();
                addRule('#M' + dbid, 'display: none;');
                store.dispatch({
                    type: 'removeComment',
                    value: dbid
                });
            }).catch((reason) => {
                if (reason && reason.responseJSON && reason.responseJSON.needLogin)
                    E.showLoginModal({reason: E.showLoginModal.messages.NUSCAST_API});
                console.log('xxxx ERR deleteComment()', reason);
            });
        }
    }

    let reply = {
        name: "Reply to this comment",
        icon: "fa-reply"
    };
    let ban = {
        name: "Ban this user",
        className: "text-danger",
        icon: "fa-ban",
        disabled: function (key, opt) {
            let banlist = getBanlist();
            let user = opt.$trigger[0].getAttribute('data-user').toUpperCase();
            return banlist.indexOf(user) >= 0;
        }
    };
    let unban = {
        name: "Un-Ban this user",
        icon: "fa-recycle",
        disabled: function (key, opt) {
            let banlist = getBanlist();
            let user = opt.$trigger[0].getAttribute('data-user').toUpperCase();
            return banlist.indexOf(user) < 0;
        }
    };
    let goto = {
        name: "Jump to this comment",
        icon: "fa-plane"
    };
    let del = {
        name: "Delete this comment",
        icon: "fa-trash",
        className: "text-danger"
    };
    let user = store.getState().user;
    window.$.contextMenu({
        selector: '.cmt-list.cmt-other',
        trigger: 'left',
        itemClickEvent: "click",
        callback: menuCallBack,
        items: user ? {
            goto,
            reply,
            ban,
            unban
        } : {
            goto
        }
    });
    window.$.contextMenu({
        selector: '.cmt-list.cmt-other',
        itemClickEvent: "click",
        callback: menuCallBack,
        items: user ? {
            goto,
            reply,
            ban,
            unban
        } : {
            goto
        }
    });
    window.$.contextMenu({
        selector: '.cmt-list.cmt-self',
        trigger: 'left',
        itemClickEvent: "click",
        callback: menuCallBack,
        items: user ? {
            goto,
            del
        } : {
            goto
        }
    });
    window.$.contextMenu({
        selector: '.cmt-list.cmt-self',
        itemClickEvent: "click",
        callback: menuCallBack,
        items: user ? {
            goto,
            del
        } : {
            goto
        }
    });
    if (user) {
        window.$.contextMenu({
            selector: '.cmt.cmt-other.paused',
            itemClickEvent: "click",
            callback: menuCallBack,
            items: {
                reply,
                ban,
                unban
            }
        });
        window.$.contextMenu({
            selector: '.cmt.cmt-self.paused',
            itemClickEvent: "click",
            callback: menuCallBack,
            items: {
                del
            }
        });
    }
}

E.handleVideoPlayerMounted = function (videoPlayerDom, videoDom) {
    let ID = E.getVidFromPathname();
    let currentVideo = store.getState().currentVideo;
    if (!ID) {
        // promo mode
        if (!currentVideo) {
            return E.getPromoVideos();
        }
    } else {
        if (!currentVideo) {
            return E.getVideoInfo();
        } else if (ID !== currentVideo.ID && currentVideo.ID !== 'public_404') {
            return E.getVideoInfo(currentVideo);
        }
    }
    if (currentVideo.src !== videoDom.nuscastSrc) {
        videoDom.nuscastSrc = currentVideo.src;
        if (/\.m3u8/i.test(currentVideo.src)) {
            let hls = E.hlsinst = new window.Hls();
            hls.loadSource(currentVideo.src);
            hls.attachMedia(videoDom);
        } else {
            videoDom.src = currentVideo.src;
        }
    }
    if (E.abpinst) {
        return;
    }
    let inst = E.abpinst = window.ABP.create(videoPlayerDom, {
        src: {
            playlist: [{
                video: videoDom,
                comments: E.getComments(currentVideo.ID)
            }]
        },
        width: 960,
        height: 647,
        mobile: false
    });
    let user = (store.getState().user && store.getState().user.userID) || 'guest';
    E.abpinst.user = user;
    E.abpinst.cmManager.options.global.user = user;
    inst.playerUnit.addEventListener("sendcomment", E.handleSendComment);
    function handleVideoElementPanoptoError(e) {
        let error = inst.video.error;
        if (error && error.code === 4) {
            inst.panoptoError = inst.panoptoError ? inst.panoptoError + 1 : 1;
            if (inst.panoptoError > 1) {
                E.showLoginModal({reason: E.showLoginModal.messages.panopto});
                window.$(inst.video).off('error', handleVideoElementPanoptoError);
            } else
                nuscastApi.loginToPanopto().then(_ => inst.video.src = currentVideo.src);
        }
        console.log('xxxx ERR inst.video', e, error);
    }

    setContextMenu();
    E.abpinst.moveToTime(getStime(getQueryParam('stime')));
    window.$(inst.video).on('error', handleVideoElementPanoptoError);
    if (currentVideo && currentVideo.ID) {
        socket.on(currentVideo.ID, handleRTComment);
    }
    /*
    //Temporary comment out due to project evaluation
    if (currentVideo.ID.search('public') === -1 && currentVideo.comments < 20)
        setTimeout(E.genComments, 3000);
    */
};

E.handleVideoPlayerUnmounted = function () {
    let currenVideo = store.getState().currentVideo;
    if (currenVideo && currenVideo.ID) {
        socket.removeListener(currenVideo.ID, handleRTComment);
    }
    window.$.contextMenu('destroy');
    store.dispatch({type: 'clearComment', value: null});
    removeRules('#M');
    E.abpinst = window.abpinst = null;
    E.hls = null;
    store.dispatch({type: 'currentVideo', value: null});
};

E.genComments = function () {
    if (!E.abpinst)
        return void console.log('xxxx try to sendComment but no abp');
    let v = store.getState().currentVideo;
    let dur = E.abpinst && E.abpinst.video && E.abpinst.video.duration;
    if (!dur || !isFinite(dur))
        dur = 600;
    let pool = ['test' + Date.now(), '666', '233', '?', 'lol', 'dont understand', '???', 'who else watching?',
        'like if you are directed here by Godness Madoka', 'speak louder prof', 'NUS', 'ivle sucks', 'sg',
        'soc'];
    let commentPromise;
    if (v && v.name) {
        commentPromise = nuscastApi.getGenComments(v);
    } else {
        commentPromise = Promise.resolve([pool[Math.floor(Math.random() * pool.length)]]);
    }
    commentPromise
        .then(messages => {
            function sendGenComments() {
                for (let message of messages) {
                    (function (message) {
                        setTimeout(() => {
                            E.handleSendComment({
                                detail: {
                                    message,
                                    playTime: Math.random() * dur,
                                    border: false,
                                    user: 'admin',
                                    color: 16777215,
                                    mode: 1,
                                    fontsize: 25
                                }
                            }, false);
                        }, 5000 + Math.random() * 20000);
                    })(message);
                }
            }

            window.$(E.abpinst.video).one('timeupdate', sendGenComments);
        })
        .catch(reason => {
            if (reason && reason.responseJSON && reason.responseJSON.needLogin)
                E.showLoginModal({reason: E.showLoginModal.messages.NUSCAST_API});
            console.log('xxxx ERR E.genComments()', reason);
        });
};

E.getReplies = function (e) {
    nuscastApi.getReplies().then((replies) => {
        store.dispatch({type: 'replies', value: replies.reply});
    }).catch((reason) => {
        if (reason && reason.responseJSON && reason.responseJSON.needLogin)
            E.showLoginModal({reason: E.showLoginModal.messages.NUSCAST_API});
        console.log('xxxx ERR E.getReplies()', reason);
    });
};

E.deleteReply = function (_id) {
    nuscastApi.deleteReply(_id).then((replies) => {
        store.dispatch({type: 'replies', value: replies.reply});
    }).catch((reason) => {
        if (reason && reason.responseJSON && reason.responseJSON.needLogin)
            E.showLoginModal({reason: E.showLoginModal.messages.NUSCAST_API});
        console.log('xxxx ERR E.deleteReply()', reason);
    });
};

function handleRTComment(d) {
    let c = d.c.split(',');
    let userID = c[4];
    let user = store.getState().user;
    let border = user && user.userID && user.userID === userID;
    renderComment(d, border, !border, border);
}

function renderComment(cmt, now = true, isAdmin = false, border = true) {
    let c = cmt.c.split(',');
    let m = cmt.m;
    let stime = Number(c[0]);
    let color = Number(c[1]);
    let mode = Number(c[2]);
    let fontSize = Number(c[3]);
    let userID = c[4];
    let date = Number(c[5]);
    let commentId = c[6];
    let set = store.getState().comments;
    if (!set.has(commentId)) {
        store.dispatch({
            type: 'addComment',
            value: commentId
        });
        E.abpinst.hideReply();
        E.abpinst.cmManager.sendComment({
            "text": m,
            "mode": mode,
            "stime": stime * 1000,
            "size": fontSize,
            "color": color,
            "hash": userID,
            "dbid": commentId,
            "border": border
        }, now && E.abpinst.video.currentTime !== 0);
        E.abpinst.commentList[commentId] = {
            "date": date,
            "time": stime * 1000,
            "mode": mode,
            "user": userID,
            "pool": 0,
            "content": m
        };
        E.abpinst.loadCommentList('time','asc');
        if (!isAdmin) {
            E.abpinst.txtText.value = "";
            E.abpinst.txtText.disabled = true;
            setTimeout(function () {
                E.abpinst.txtText.disabled = false;
            }, E.abpinst.commentCoolDown);
        }
    }
}

E.handleSendComment = function (e, now = true) {
    function getCommentObjFromEvent(e) {
        let c = {c: '', m: e.detail.message};
        c.c += e.detail.playTime + ',';
        c.c += e.detail.color + ',';
        c.c += e.detail.mode + ',';
        c.c += e.detail.fontsize + ',';
        c.c += (e.detail.user || (store.getState().user && store.getState().user.userID) || 'guest');
        if (e.detail.reply) c.reply = e.detail.reply;
        return c;
    }

    if (!E.abpinst)
        return void console.log('xxxx try to sendComment but no abp', e);
    let c = getCommentObjFromEvent(e);
    let ID = store.getState().currentVideo && store.getState().currentVideo.ID;
    let isAdmin = e.detail.user === 'admin';
    if (ID) {
        nuscastApi.sendComment(c, ID, isAdmin).then(d => {
            renderComment(d, now, isAdmin, e.detail.border);
        }).catch(reason => {
            if (reason && reason.responseJSON && reason.responseJSON.needLogin)
                E.showLoginModal({reason: E.showLoginModal.messages.NUSCAST_API});
            else {
                store.dispatch({
                    type: 'addAlert',
                    value: {
                        title: 'Danmaku launching failed!',
                        content: 'Probably you are sending too fast, or probably you are sending as wrong user?\nTry sending again 🙈;',
                        type: 'warning'
                    }
                });
            }
            console.log('xxxx ERR nuscastApi.handleSendComment()', reason)
        });
    }
};

E.getPromoVideos = function () {
    nuscastApi.getPromoVideos()
        .then(d => {
            d = d.filter(function (item) {
                return item.ID !== 'public_404';
            });
            let video = d[Math.floor(Math.random() * d.length)];
            E.getVideoInfo(null, video.ID);
        })
        .catch(reason => {
            if (reason && reason.responseJSON && reason.responseJSON.needLogin)
                E.showLoginModal({reason: E.showLoginModal.messages.NUSCAST_API});
            console.log('xxxx ERR E.getPromoVideos()', reason);
        });
};

E.getThumbnailUrlOrPlaceholder = function (video) {
    let thumbnail = video && video.thumbnail !== '' && video.thumbnail;
    if (thumbnail) {
        return thumbnail;
    }
    return `${process.env.PUBLIC_URL}/img/thumbnail.png`;
};

E.getVidFromPathname = function () {
    let location = store.getState().routing.locationBeforeTransitions;
    if (location.params && location.params['vid'])
        return location.params['vid'];
    let match = /\/v\/([0-9a-zA-Z-_]+)/.exec(location.pathname);
    if (match && match[1])
        return match[1];
    return null;
};

E.goBack = function (e) {
    if (window.location.pathname !== '/') {
        history.goBack();
    }
    e.preventDefault();
};

E.collapseMemory = function () {
    window.$(document).on('hidden.bs.collapse', function (e) {
        let value = {};
        value[e.target.id] = false;
        if (e.target.id)
            store.dispatch({type: 'collapse', value});
    });
    window.$(document).on('shown.bs.collapse', function (e) {
        let value = {};
        value[e.target.id] = true;
        if (e.target.id)
            store.dispatch({type: 'collapse', value});
    });
};

E.showLoginModal = function (opt) {
    window.$('.login-modal-message').text(opt.reason);
    window.$('#modalLogin').modal('show');
};

E.showLoginModal.messages = {
    nuscastApi: 'Some request failed and it seems your session expired\n'
    + 'Please try logging in again below (you can use TAB to switch focus and ENTER to submit)',
    login: 'Login via IVLE below',
    panopto: 'IVLE is refusing to provide video. Please try to login again below\n'
    + 'In case re-login doesn\'t work, please try to clear your browser cookie on ivle.nus.edu.sg. Sorry for the inconvenice!'
};

E.startLoader = function (opt) {
    opt = opt || {};
    if (!opt.msg)
        opt.msg = '"IVLE, please respond! I repeat..."';
    if (!E.loaderElement) {
        E.loaderElement = window.$('<div class="loader-message">' + opt.msg + '</div>');
        window.$.LoadingOverlaySetup({
            image: process.env.PUBLIC_URL + '/img/loader.gif',
            custom: E.loaderElement,
            color: 'rgba(255,255,255,0.9)',
            fade: [400, 400]
        });
    }
    E.loaderElement.text(opt.msg);
    if (opt.elem)
        window.$(opt.elem).LoadingOverlay('show', {custom: ''});
    else
        window.$.LoadingOverlay('show');
};

E.stopLoader = function (opt) {
    opt = opt || {};
    if (opt.elem)
        window.$(opt.elem).LoadingOverlay('hide');
    else
        window.$.LoadingOverlay('hide');
};

export default E;


// WEBPACK FOOTER //
// ./src/applogic.js